"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var LocationIcon = function () {
    return (react_1.default.createElement("svg", { className: styles_module_scss_1.default.svg, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 22.5 30" },
        react_1.default.createElement("g", { transform: "translate(-4.75 -1)" },
            react_1.default.createElement("path", { d: "M27.25,12.25c0,4.536-1.581,5.8-10.094,18.145a1.407,1.407,0,0,1-2.312,0C6.331,18.053,4.75,16.786,4.75,12.25a11.25,11.25,0,0,1,22.5,0Zm-1.875,0a9.375,9.375,0,0,0-18.75,0c0,3.779,1.213,4.716,9.375,16.519C24.162,16.965,25.375,16.029,25.375,12.25Zm-3.75,0A5.625,5.625,0,1,1,16,6.625,5.632,5.632,0,0,1,21.625,12.25Zm-1.875,0A3.75,3.75,0,1,0,16,16,3.754,3.754,0,0,0,19.75,12.25Z", fill: "#b5b5b5" }))));
};
exports.default = react_1.memo(LocationIcon);
